// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"lba-z","colorTextValue":"mba-z","swatches":"nba-z","collapseLink":"oba-z","isCollapsed":"pba-z","dropdown":"qba-z","disabled":"rba-z"};